import { ipifyApi } from "./ipify.api";

export const { useGetIpQuery } = ipifyApi;
